import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * Lightweight mediator between credit-consuming API calls and TransactionService credit refresh.
 * Used by services such as CandidateService and PersonSearchService after credit-consuming actions.
 * Avoids a circular dependency because TransactionService depends on PersonSearchService.
 * PersonSearchService therefore signals credit changes through this neutral service instead.
 */
@Injectable({
  providedIn: 'root'
})
export class CreditActivityService {

  private creditConsumed: Subject<void> = new Subject<void>();

  /** Emits whenever a credit-consuming action has succeeded and credits should be refreshed. */
  get creditConsumed$(): Observable<void> {
    return this.creditConsumed.asObservable();
  }

/**
 * Call after a credit-consuming action succeeds.
 * TransactionService listens and refreshes credits automatically.
 * Callers do not need to trigger a credits refresh manually.
 */
  notifyCreditConsumed(): void {
    this.creditConsumed.next();
  }
}
